import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './BulkPurchaseSuccessPage.css';

const BulkPurchaseFailPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const message = params.get('message') || '결제가 완료되지 않았습니다.';
  const code = params.get('code');
  const orderId = params.get('orderId');

  const isCancel = code === 'PAY_PROCESS_CANCELED' || /취소/.test(message);

  return (
    <div className="bps-page">
      <div className="bps-container">
        <div className="bps-error-box">
          <h1>{isCancel ? '결제가 취소되었습니다' : '결제에 실패했습니다'}</h1>
          <p>{message}</p>
          <p className="bps-error-hint">
            카드 한도·잔액·정보를 확인하신 뒤 다시 시도해주세요.
            계속 실패하면 <a href="mailto:angel@plactical.com">angel@plactical.com</a> 으로 문의해주세요.
          </p>
          {orderId && <p className="bps-error-orderid">주문번호: <code>{orderId}</code></p>}
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: 16 }}>
            <button className="bps-btn-secondary" style={{ flex: 0, padding: '0 20px' }} onClick={() => navigate('/pricing')}>견적서로</button>
            <button className="bps-btn-primary" style={{ flex: 0, padding: '0 20px' }} onClick={() => navigate('/bulk-purchase?intent=pay')}>다시 결제</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkPurchaseFailPage;
